import Vue from 'vue'
import {Events, Requests} from './core-consts'
import {Intent} from './core-intent'
import store from './store'
import WebClient from '@utils/webClient'

function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value)
}

// ws-connector service client
let webClient = new WebClient()
webClient.onready = function () {
  console.log('-- onready')
  webClient.send(Requests.WebClientAuth)
}

webClient.onuserauthorized = (args) => store.dispatch('userAuthorized', args)
webClient.onblockusercomplete = (args) => EventBus.onBlockContact(args)
webClient.onunblockusercomplete = (args) => EventBus.onUnblockContact(args)
webClient.onunblockallcomplete = (args) => EventBus.$emit('all-contacts-unblocked', args)
webClient.onverifyusercomplete  = (args) => EventBus.onVerifyUser(args)
webClient.onchatchanged = (args) => EventBus.$emit('chat-changed', args)
webClient.onchatttlchanged = (args) => store.dispatch('chatTtlChanged', args)
webClient.onchatunreadchanged = (args) => EventBus.$emit('chat-unread-changed', args)
webClient.onchatttlmessageprogress = (args) => EventBus.$emit('chat-ttl-message-progress', args)
webClient.onchattypingupdated = (args) => EventBus.$emit('chat-typing-updated', args)
webClient.onchatmessageupdated = (args) => EventBus.$emit('chat-message-updated', args)
webClient.onshowmessage = (args) => EventBus.$emit('show-message', args)
webClient.onstatuschanged = (args) => store.dispatch('updateConnectionState', args.state)


webClient.onreplycallback = function replyCallback(args) {
  switch (args.action) {
    case Requests.GetContacts:
      EventBus.onGetContacts(args.contacts)
      break
    case Requests.GetBlockedContacts:
      EventBus.onGetBlockedContacts(args.contacts)
      break
    case Requests.GetChats:
      EventBus.onGetChats(args.chats)
      break
    case Requests.GetChatMessages:
      EventBus.onGetChatMessages(args.messages)
      break
    case Requests.GetChatMessage:
      EventBus.onGetChatMessage(args)
      break
    case Requests.GetRecentCalls:
      EventBus.onGetRecentCalls(args.calls)
      break 
    case Requests.GetUserProfile:
      EventBus.onGetUserProfile(args)
      break
    case Requests.RestoreDraft:
      EventBus.onRestoreDraft(args)
      break
    case Requests.DecodeFile:
      EventBus.onDecodeFile(args)
      break
    case Requests.CreateChat:
      console.debug('-- CreateChat', args)
      EventBus.onCreateChat(args)
      break
    case Requests.OpenSingleChat:
      EventBus.onOpenSingleChat(args.chatId)
      break
    case Requests.GetChatUnreadCount:
      EventBus.onGetChatUnreadCount(args)
      break
    case Requests.GetUnreadCount:
      EventBus.onGetUnreadCount(args.unread)
      break
    
    case Requests.ReadFile:
      //EventBus.onreadfile({ file:arg.file, data:arg.data })
      break
  }
}

Vue.prototype.launch = async function() {
  console.log('-- launch')
  window.launched = true
}

Vue.prototype.getLogin = function() {
  return this.login ? this.login : ''
}

Vue.prototype.getContacts = function() {
  return new Promise(resolve => {
    this.onGetContacts = (items) => {
      this.contacts = items
      resolve(items)
    }
    webClient.send(Requests.GetContacts)
  })
}

Vue.prototype.getBlockedContacts = function() {
  return new Promise(resolve => {
    this.onGetBlockedContacts = (items) => resolve(items)
    webClient.send(Requests.GetBlockedContacts)
  })
}

Vue.prototype.blockContact = function(contactId) {
  return new Promise(resolve => {
    this.onBlockContact = (args) => resolve(args.state)
    webClient.send(Requests.BlockContact, {
      contact: webClient.buildWebContact(contactId)
    })
  })
}

Vue.prototype.unblockContact = function(contactId) {
  return new Promise(resolve => {
    this.onUnblockContact = (args) => resolve(args.state)
    webClient.send(Requests.UnblockContact, {
      contact: webClient.buildWebContact(contactId)
    })
  })
}

Vue.prototype.unblockAllContacts = function() {
  return new Promise(resolve => {
    //this.onUnblockAllContacts = (result) => resolve(result)
    webClient.send(Requests.UnblockAllContacts)
    resolve()
  })
}

Vue.prototype.verifyUser = function(contactId) {
  return new Promise(resolve => {
    this.onVerifyUser = (data) => resolve(data)
    const msg = webClient.buildWebContact(contactId)
    webClient.send(Requests.VerifyContact, {contact: msg})
  })
}

Vue.prototype.addContact = function(contactId, name, avatar) {
  console.log('-- add: ', contactId, name, avatar)
  return new Promise(resolve => {
    const msg = webClient.buildWebContact(contactId, name, avatar)
    webClient.send(Requests.AddContact, {contact: msg})
    resolve()
  })
}

Vue.prototype.removeContact = function(contactId) {
  return new Promise(resolve => {
    webClient.send(Requests.RemoveContact, {
      contact: webClient.buildWebContact(contactId)
    })
    resolve()
  })
}

Vue.prototype.getChats = function() {
  return new Promise(resolve => {
    this.onGetChats = (items) => {
      this.chats = items
      resolve(items)
    }
    webClient.send(Requests.GetChats)
  })
}

Vue.prototype.getChatMessages = function(chatId, offset) {
  return new Promise(resolve => {
    this.onGetChatMessages = (items) => resolve(items)
    webClient.send(Requests.GetChatMessages, {chatId, offset})
  })
}

Vue.prototype.getChatMessage = function(chatId, messageId) {
  return new Promise(resolve => {
    this.onGetChatMessage = (msg) => resolve(msg)
    webClient.send(Requests.GetChatMessage, {chatId, messageId})
  })
}

Vue.prototype.getChatTtl = function(chatId) {
  let chat = this.chats.filter(it => it.chatId == chatId)
  return (chat) ? chat.ttl : 0
}

Vue.prototype.getChatUnreadCount = function(chatId) {
  return new Promise(resolve => {
    this.onGetChatUnreadCount = (data) => resolve(data)
    webClient.send(Requests.GetChatUnreadCount, {chatId})
    //resolve()
  })
}

Vue.prototype.getUnreadCount = function() {
  return new Promise(resolve => {
    this.onGetUnreadCount = (unread) => resolve(unread)
    webClient.send(Requests.GetUnreadCount)
    //resolve()
  })  
}

Vue.prototype.removeChat = function(chatId) {
  return new Promise(resolve => {
    webClient.send(Requests.RemoveChat, {chatId})
    resolve()
  })
}

Vue.prototype.restoreDraft = function(chatId) {
  return new Promise(resolve => {
    this.onRestoreDraft = (args) => {
      let chat = this.chats.filter(it => it.chatId == chatId)
      if (chat) chat.draft = args.draft
      resolve(args.draft)
    }
    webClient.send(Requests.RestoreDraft, {chatId})
  })
}

Vue.prototype.storeDraft = function(chatId, draft) {
  let chat = this.chats.filter(it => it.chatId == chatId)
  if (chat) chat.draft = draft
  return new Promise(resolve => {
    webClient.send(Requests.StoreDraft, {chatId, draft})
    resolve()
  })
}

Vue.prototype.toggleTimerMonitoring = function(chatId) {
  // TODO: mobile and web can see different chats!
  /*let req = Intent.request(Requests.ToggleTimerMonitoring)
  req.chatId = chatId
  return new Promise(resolve => {
    //webClient.send(req)
    resolve()
  }) */
}

Vue.prototype.sendChatTyping = function(chatId, typing) {
  return new Promise(resolve => {
    webClient.send(Requests.SendChatTyping, {chatId, typing})
    resolve()
  })
}

Vue.prototype.createChat = function(users) {
  return new Promise(resolve => {
    this.onCreateChat = (args) => resolve(args.chatId)
    webClient.send(Requests.CreateChat, {users})
  })
}

Vue.prototype.setChatDetails = function(chatId, avatar, title) {
  return new Promise(resolve => {
    webClient.send(Requests.SetChatDetails, {chatId, file:avatar, title})
    resolve()
  })
}

Vue.prototype.addUsersToChat = function(chatId, users) {
  return new Promise(resolve => {
    webClient.send(Requests.AddUsersToChat, {chatId, users})
    resolve()
  })
}

Vue.prototype.openSingleChat = function(contactId) {
  return new Promise(resolve => {
    this.onOpenSingleChat = (chatId) => resolve(chatId)
    webClient.send(Requests.OpenSingleChat, {users:[contactId]})
  })
}

Vue.prototype.sendChatTtl = function(chatId, ttl) {
  return new Promise(resolve => {
    webClient.send(Requests.SendChatTtl, {chatId, ttl})
    resolve()
  })
}

Vue.prototype.leaveChat = function(chatId) {
  return new Promise(resolve => {
    webClient.send(Requests.LeaveChat, {chatId})
    resolve()
  })
}

Vue.prototype.sendChatMessage = function(chatId, content, type, extra) {
  return new Promise(resolve => {
    webClient.send(Requests.SendChatMessage, {chatId, content, type, extra})
    resolve()
  })
}

Vue.prototype.sendChatFile = function(chatId, file, thumb, type, extra) {
  console.log('-- sendChatFile', {chatId, type, extra})
  return new Promise(resolve => {
    extra = webClient.buildWebExtra(extra)
    webClient.send(Requests.SendChatFile, {chatId, file, thumb, type, extra})
    resolve()
  })
}

Vue.prototype.removeChatMessage = function(chatId, messageId, remotely) {
  return new Promise(resolve => {
    webClient.send(Requests.RemoveChatMessage, {chatId, messageId, remotely})
    resolve()
  })
}

Vue.prototype.forwardChatMessage = function(recipientChat, chatId, messageId) {
  console.log('-- forwardChatMessage not implemented')
}

Vue.prototype.decodeFile = function(filepath) {
  console.log('-- decodeFile: ', filepath)
  return new Promise(resolve => {
    this.onDecodeFile = (data) => resolve(data.data)
    webClient.send(Requests.DecodeFile, {content: filepath})
  })
}

Vue.prototype.decodeFileToFile = function(filePath, outputFilePath) {
  console.log('-- decodeFileToFile not implemented')
}

Vue.prototype.clearChatMessages = function(chatId) {
  return new Promise(resolve => {
    webClient.send(Requests.ClearChatMessages, {chatId})
    resolve()
  })
}

Vue.prototype.setChatMuted = function(chatId, muted) {
  return new Promise(resolve => {
    webClient.send(Requests.SetChatMuted, {chatId, muted})
    resolve()
  })
}

Vue.prototype.markReadChatMessage = function(chatId, messageId) {
  return new Promise(resolve => {
    webClient.send(Requests.MarkReadChatMessage, {chatId, messageId})
    resolve()
  })
}

Vue.prototype.getUserProfile = function(contactId) {
  let el = this.contacts.find(it => it.contactId == contactId)
  return el ? el : {}
}

Vue.prototype.updateUserProfile = function(key, value) {
  return new Promise(resolve => {
    const account = webClient.buildWebAccountDetails(
      (key === 'name') ? value : null,
      (key === 'email') ? value : null,
      (key === 'phone') ? value : null,
      (key === 'avatar') ? value : null
      )
    webClient.send(Requests.UpdateAccountDetails, {account})
    resolve()
  })
}

Vue.prototype.getRecentCalls = function() {
  return new Promise(resolve => {
    this.onGetRecentCalls = (items) => resolve(items)
    webClient.send(Requests.GetRecentCalls)
  })
}

Vue.prototype.removeRecent = function(index) {
  console.log('-- removeRecent not implemented')
}

Vue.prototype.removeAllRecents = function() {
  console.log('-- removeAllRecents not implemented')
}

Vue.prototype.markUnreadRecents = function() {
  console.log('-- markUnreadRecents not implemented')
}

Vue.prototype.call = function() {
  console.log('-- call not implemented')
}

Vue.prototype.acceptCall = function() {
  console.log('-- acceptCall not implemented')
}

Vue.prototype.declineCall = function() {
  console.log('-- declineCall not implemented')
}

Vue.prototype.muteMicrophone = function(mute) {
  console.log('-- muteMicrophone not implemented')
}

Vue.prototype.getCallUsers = function() {
  console.log('-- getCallUsers not implemented')
  return []
}

Vue.prototype.getCoreVersion = function() {
  console.log('-- getCoreVersion not implemented')
  return ""
}

Vue.prototype.isApplicationPinSet = function() {
  console.log('-- isApplicationPinSet not implemented')
  return false
}

// TODO: deprecated?
Vue.prototype.readFile = function(file) {
  return new Promise(resolve => {
    this.onreadfile = (data) => resolve({ file, data })
    webClient.send(Requests.ReadFile, {file})
  })
}

Vue.prototype.createBackup = function(filepath, password, withMedia) {
  console.log('-- createBackup not implemented')
}

Vue.prototype.restoreBackup = function(filepath, password) {
  console.log('-- restoreBackup not implemented')
}

Vue.prototype.getUrlMetadata = function(data) {
  console.log('-- getUrlMetadata not implemented')
  return {}
}

Vue.prototype.showMainWindow = function() {

}

Vue.prototype.connectWsc = function() {
  //const url = 'ws://cryspprod1.quantag-it.com:5567/userBin'
  let url = 'wss://cryspprod1.quantag-it.com/ws/userBin'

  console.log('-- connect to', url)
  return new Promise(resolve => {
    webClient.openWscs(url).then(s => {
      // TODO: temporary for core
      url = 'ws://cryspprod1.quantag-it.com:5567/userBin'
      resolve(s ? url : '')
    })
  })
}

Vue.prototype.registerWscToken = function(token) {
  return webClient.registerWscs(token)
}

export const EventBus = new Vue()
